module.exports = "<div class=\"select-list\">\n  <mat-form-field class=\"example-full-width\">\n    <input #timeInput matInput placeholder=\"Введите время продления\" [(ngModel)]=\"time\">\n  </mat-form-field>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-incress-time/order-incress-time.component.html
// module id = ./src/app/dashboard/order-incress-time/order-incress-time.component.html
// module chunks = main